module.exports = __webpack_public_path__ + "static/media/ssec1.8901092d.png";